<script setup>
const props = defineProps({ data: Object });
const localePath = useLocalePath();
// const { date, tags, timeFrom, timeEnd, featuredImage, slug } = data;

const title = props.data.eventsConfig.title || props.data.title;
const tags = props.data.eventTags.edges;
const timeFrom = props.data.eventsConfig.datesettings.timeFrom;
const timeEnd = props.data.eventsConfig.datesettings.timeEnd;
const featuredImage =
  props.data.eventsConfig?.featuredImage?.mediaItemUrl || null;
const slug = props.data.slug;
const date = props.data.date;

const { locale } = useI18n();
const getWeekdayName = (dateString, locale) => {
  // Create a new Date object (month is 0-indexed in JavaScript)
  const date = new Date(dateString);

  // Return the weekday name
  return date.toLocaleDateString(locale, { weekday: "long" });
};

const getDate = (datestring) => {
  const date = new Date(datestring);
  return `${date.getDate() < 10 ? "0" : ""}${date.getDate()}.${
    date.getMonth() + 1 < 10 ? "0" : ""
  }${date.getMonth() + 1}.`;
};

const navigate = () => {
  return navigateTo(localePath({ name: "event-id", params: { id: slug } }));
};
</script>

<template>
  <div
    @click="navigate"
    class="relative z-40 md:flex calendar-event-row py-6 pt-12 md:pt-6 cursor-pointer transition-transform xl:hover:scale-[102%] 2xl:hover:scale-105"
  >
    <img
      v-if="featuredImage"
      class="md:hidden w-full pb-3 md:pb-4"
      :src="featuredImage"
    />
    <div class="pr-16 lg:pr-28 pb-3 md:pb-0 flex md:block items-end gap-4">
      <h2 class="h1 !font-medium">
        {{ date ? getDate(date) : "" }}
      </h2>
      <div class="font-bold uppercase">
        {{ date ? getWeekdayName(date, locale) : "" }}
      </div>
    </div>
    <div v-if="featuredImage" class="pr-10">
      <img class="hidden md:block" :src="featuredImage" />
    </div>
    <div>
      <div class="txt-q">{{ title }}</div>
      <div class="pt-3 md:pt-4">
        <div
          class="flex gap-4 flex-wrap font-bold items-center whitespace-nowrap"
        >
          {{ timeFrom }}
          {{ timeEnd ? ` - ${timeEnd}` : "" }}
          <div class="flex gap-2">
            <div v-for="(tag, i) in tags" :key="i" class="event-tag">
              {{ tag.node.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.calendar-event-row {
  img {
    height: 160px;
    width: 280px;
    max-width: 280px;
    object-fit: cover;

    @media (max-width: 768px) {
      aspect-ratio: 380 / 213;
      height: auto;
      width: 100%;
      max-width: 100%;
      object-fit: cover;
    }
  }
  @media (max-width: 768px) {
    width: 100%;
  }
}

.calendar-event-row {
  border-bottom: 1px solid black;
}
</style>

<style lang="scss">
.event-tag {
  background: $color-primary;
  border-radius: 100px;
  padding: 4px 12px;
  font-weight: 400;
}
</style>
